"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_navigation_1 = require("@carvana/helios-navigation");
var test_attributes_1 = require("@carvana/test-attributes");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var PlateEntry_1 = __importDefault(require("../PlateEntry"));
var usaStates_1 = __importDefault(require("../PlateEntry/usaStates"));
var VinEntry_1 = __importDefault(require("../VinEntry"));
var PlateVinEntry_helpers_1 = require("./PlateVinEntry.helpers");
var PlateVinEntry_styles_1 = require("./PlateVinEntry.styles");
var lettersToNumbers = {
    I: '1',
    O: '0',
    Q: '9'
};
var vinValidationErrorText = function (letter) {
    return letter && letter in lettersToNumbers
        ? "The letter '".concat(letter, "' is invalid. Try the number '").concat(lettersToNumbers[letter], "' instead.")
        : '';
};
var requiredFieldMessage = 'This field is required.';
var PlateVinEntry = function (_a) {
    var _b = _a.queryParams, queryParams = _b === void 0 ? {} : _b, submitPlateVin = _a.submitPlateVin, _c = _a.submitText, submitText = _c === void 0 ? 'Get My Offer' : _c;
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var _d = (0, react_1.useState)(''), plate = _d[0], setPlate = _d[1];
    var _e = (0, react_1.useState)(false), plateError = _e[0], setPlateError = _e[1];
    var _f = (0, react_1.useState)(''), plateState = _f[0], setPlateState = _f[1];
    var _g = (0, react_1.useState)(false), plateStateError = _g[0], setPlateStateError = _g[1];
    var _h = (0, react_1.useState)(''), vin = _h[0], setVin = _h[1];
    var _j = (0, react_1.useState)(false), vinError = _j[0], setVinError = _j[1];
    var _k = (0, react_1.useState)(undefined), incorrectLetter = _k[0], setIncorrectLetter = _k[1];
    var _l = (0, react_1.useState)(false), touched = _l[0], setTouched = _l[1];
    var _m = (0, react_1.useState)(true), plateVisible = _m[0], setPlateVisible = _m[1];
    var getFirstQueryParam = function (param) {
        var _a;
        if (Array.isArray(param)) {
            return (_a = param[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        }
        return param === null || param === void 0 ? void 0 : param.toUpperCase();
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        var plateParam = (_a = queryParams === null || queryParams === void 0 ? void 0 : queryParams.licensePlate) !== null && _a !== void 0 ? _a : '';
        setPlate(getFirstQueryParam(plateParam));
        setPlateState(getFirstQueryParam((_b = queryParams === null || queryParams === void 0 ? void 0 : queryParams.plateState) !== null && _b !== void 0 ? _b : ''));
        var vinValue = getFirstQueryParam((_c = queryParams === null || queryParams === void 0 ? void 0 : queryParams.vin) !== null && _c !== void 0 ? _c : '');
        setVin(vinValue);
        setPlateVisible(!vinValue);
    }, [queryParams.licensePlate, queryParams.plateState, queryParams.vin]);
    var plateVisibleToggle = function (val) {
        setPlateVisible(val.toLowerCase() === 'plate');
        setTouched(false);
    };
    var updatePlate = function (_a) {
        var target = _a.target;
        var value = target.value;
        setPlateError(!value);
        setPlate(value === null || value === void 0 ? void 0 : value.toUpperCase().slice(0, 8));
    };
    var updatePlateState = function (value) {
        setPlateStateError(!value || !usaStates_1.default.find(function (state) { return state === value.toUpperCase(); }));
        setPlateState(value.toUpperCase().slice(0, 2));
    };
    var getRequiredVinError = function () {
        if (!vin) {
            return requiredFieldMessage;
        }
        if (incorrectLetter) {
            return vinValidationErrorText(incorrectLetter);
        }
        if (vin.length !== 17) {
            return 'Invalid VIN.';
        }
        if (vinError) {
            return vinError;
        }
        return '';
    };
    var updateVin = function (_a) {
        var target = _a.target;
        var value = target.value;
        if (value) {
            var regResult = (0, PlateVinEntry_helpers_1.getInvalidVINLetter)(value);
            setVinError(!!regResult);
            if (regResult) {
                var firstInvalidLetter = regResult[0].toUpperCase();
                setIncorrectLetter(firstInvalidLetter);
            }
            else {
                setIncorrectLetter(undefined);
            }
            value = value
                .replace(/[^A-Z0-9]/gi, '')
                .toUpperCase()
                .slice(0, 17);
        }
        else {
            setVinError(true);
            setIncorrectLetter(undefined);
        }
        setVin(value);
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        setTouched(true);
        if (plateVisible) {
            if (!plate || !plateState || plateStateError) {
                if (!plate) {
                    setPlateError(true);
                }
                if (!plateState) {
                    setPlateStateError(true);
                }
                return;
            }
            submitPlateVin({ plate: plate, plateState: plateState });
        }
        else {
            if ((0, PlateVinEntry_helpers_1.isVinValid)(vin)) {
                submitPlateVin({ vin: vin });
            }
            setVinError(true);
        }
    };
    var handleBlur = function () {
        setTouched(true);
    };
    var withVin = !plateVisible;
    var vinErrorToDisplay = touched && getRequiredVinError();
    return ((0, jsx_runtime_1.jsxs)(PlateVinEntry_styles_1.Content, { children: [(0, jsx_runtime_1.jsxs)(helios_navigation_1.Tabs, __assign({ initialTab: plateVisible ? 'Plate' : 'VIN' }, { children: [(0, jsx_runtime_1.jsxs)(helios_navigation_1.Tabs.TabBar, { children: [(0, jsx_runtime_1.jsx)(helios_navigation_1.Tabs.Tab, __assign({ tabGroup: "Plate", className: "tabStyle", onClick: function () { return plateVisibleToggle('plate'); } }, { children: "License Plate" })), (0, jsx_runtime_1.jsx)(helios_navigation_1.Tabs.Tab, __assign({ tabGroup: "VIN", className: "tabStyle", onClick: function () { return plateVisibleToggle('VIN'); } }, { children: "VIN" }))] }), (0, jsx_runtime_1.jsx)(helios_navigation_1.Tabs.TabPanel, __assign({ tabGroup: "Plate" }, { children: (0, jsx_runtime_1.jsx)(PlateEntry_1.default, { plate: plate, plateError: touched && plateError, error: touched && plateError ? requiredFieldMessage : undefined, plateState: plateState, plateStateError: plateStateError, updatePlate: updatePlate, updatePlateState: updatePlateState, onBlur: handleBlur }) })), (0, jsx_runtime_1.jsx)(helios_navigation_1.Tabs.TabPanel, __assign({ tabGroup: "VIN" }, { children: (0, jsx_runtime_1.jsx)(VinEntry_1.default, { hasError: vinError, error: vinErrorToDisplay, updateVin: updateVin, vin: vin, onBlur: handleBlur }) }))] }), "".concat(plateVisible)), (0, jsx_runtime_1.jsx)(PlateVinEntry_styles_1.SubmitInfo, __assign({}, getTestAttributes('GetMyOfferButton'), { className: (0, classnames_1.default)({ withVin: withVin }), onClick: handleSubmit }, { children: submitText }))] }));
};
exports.default = PlateVinEntry;
